import { render, staticRenderFns } from "./AgendorConfigCard.vue?vue&type=template&id=4c1f0ec3&"
import script from "./AgendorConfigCard.vue?vue&type=script&lang=ts&"
export * from "./AgendorConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports